var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing-Activity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders_Empty-list",
    transform: "translate(-28 -60)",
    fill: "#8E66D6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-/-subheader",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "org-details",
    transform: "translate(15 13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-/-Org-avatar-/-building-tall-/-purple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Org-avatar-/-building-tall-/-purple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.39 12.362c.557 0 1.008.46 1.008 1.009v4.964h1.294c.562 0 1.017.44 1.017 1v12.21c0 .004.168.012.168.012a.99.99 0 0 1 .988.997v.984a.994.994 0 0 1 .637.93v.997H13.5v-.997c0-.55.78-.997.78-.997v-.917c0-.427.267-.791.641-.933-.002-.025-.003-12.287-.003-12.287 0-.552.46-.999 1.017-.999h1.526v-4.964a1.01 1.01 0 0 1 1.007-1.009h1.42V8.875c0-.542.449-1 1.004-1h3.075c.553 0 1.004.448 1.004 1v3.487h1.42zm-7.774 1.247h1.849v1.994h-1.849v-1.994zm2.863 0h1.849v1.994h-1.85v-1.994zm2.773 0H26.1v1.994h-1.85v-1.994zm-5.636 3.24h1.849v1.995h-1.849v-1.995zm2.863 0h1.849v1.995h-1.85v-1.995zm2.773 0H26.1v1.995h-1.85v-1.995zm-5.636 3.241h1.849v1.994h-1.849V20.09zm2.863 0h1.849v1.994h-1.85V20.09zm2.773 0H26.1v1.994h-1.85V20.09zm-5.636 3.24h1.849v1.995h-1.849v-1.994zm-2.773-3.24h1.849v1.994h-1.85V20.09zm0 3.24h1.849v1.995h-1.85v-1.994zm0 3.241h1.849v1.995h-1.85V26.57zm0 3.241h1.849v1.994h-1.85v-1.994zm5.636-6.481h1.849v1.994h-1.85v-1.994zm2.773 0H26.1v1.994h-1.85v-1.994zm-5.636 3.24h1.849v1.995h-1.849V26.57zm2.863 0h1.849v6.98h-1.85v-6.98zm2.773 0H26.1v1.995h-1.85V26.57zm-5.636 3.241h1.849v1.994h-1.849v-1.994zm5.636 0H26.1v1.994h-1.85v-1.994zm2.773-9.722h1.849v1.994h-1.849V20.09zm0 3.24h1.849v1.995h-1.849v-1.994zm0 3.241h1.849v1.995h-1.849V26.57zm0 3.241h1.849v1.994h-1.849v-1.994z",
    id: "building1"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.1b0a5a27ff32b4cae109e469131584bc.svg";
export { ForwardRef as ReactComponent };